import Const from 'const';
import {LateSwapLineupViewsInterface} from 'components/organisms/late-swap/late-swap-interfaces';

class LateSwapLineupViews implements LateSwapLineupViewsInterface {
    private indexedByLineupId: {} = {};
    constructor(public readonly lineups: object[] = []) {
        lineups.map((lineup) => {
            // @ts-ignore
            this.indexedByLineupId[lineup.lineupId] = lineup;
        });
    }
    getOneByLineupId(lineupId: string): object | null {
        if (this.indexedByLineupId.hasOwnProperty(lineupId)) {
            return this.indexedByLineupId[lineupId];
        }

        return null;
    }
    getAllAsArr(): object[] {
        return Object.values(this.indexedByLineupId);
    }
}

const lateSwapLineupViews = new LateSwapLineupViews();

export default function (state = lateSwapLineupViews, action) {
    switch (action.type) {
        case Const.LATESWAP_SET_LINEUP_VIEWS:
            return new LateSwapLineupViews(action.lineups);

        case Const.FILTER_BY_SLATE:
            return new LateSwapLineupViews();

        default:
            return state;
    }
}
